import React from 'react';
import { CheckIcon, GiftIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { bonuses } from '../../data/bonuses';
import { MOCKUP_URL } from '../../data/offer';
export function Bonuses() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="bonuses-title" data-id="element-122" data-mp="18kds4d2ev9j7">
      <div className="mx-auto max-w-5xl px-5" data-id="element-123" data-mp="259ldnl315in4">
        <SectionHeading kicker="But that’s not all…" title={<span id="bonuses-title" data-id="element-125" data-mp="20aim93fz3axm">Get 5 additional professional tools included with your blueprint</span>} lead="These complementary resources help you apply the system more efficiently during equipment assessments, service documentation, and troubleshooting preparation. All five are included with your purchase." data-id="element-124" data-mp="259bo1ylwddhy" />

        <div className="mt-14 space-y-8" data-id="element-126" data-mp="kvbdle32pwsx">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl border border-line bg-ink lg:grid lg:grid-cols-[360px_1fr]" data-id="element-127" data-mp="ftvuvsodc2dp">
              <div className="relative w-full bg-white" data-id="element-128" data-mp="1jt9m4ay7qfsf">
                <div role="img" aria-label={`${b.title} mockup`} className="aspect-[5/8] w-full bg-no-repeat" style={{
              backgroundImage: `url(${MOCKUP_URL})`,
              backgroundSize: '501.6% auto',
              backgroundPosition: `${b.cropX}% 86.9%`
            }} data-id="element-129" data-mp="1jqnfqen266bs" />
                <span className="absolute left-1/2 top-[86%] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-[#1E9BFF] px-5 py-1.5 font-display text-xl font-extrabold uppercase text-white shadow-md sm:text-2xl" data-id="element-130" data-mp="10vyn8rghtodi">
                  Bonus #{b.number}
                </span>
              </div>

              <div className="flex flex-col p-6 sm:p-8" data-id="element-131" data-mp="d6e70gbq557x">
                <p className="inline-flex items-center gap-2 self-start rounded-lg bg-amber px-3 py-1 font-display text-lg font-extrabold uppercase text-ink" data-id="element-132" data-mp="i2corl2jrozd">
                  <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="2f1v5v7ds8sld" /> Free bonus #{b.number}
                </p>
                <h3 className="mt-4 font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-134" data-mp="2b005c53oej8n">
                  {b.title}
                </h3>
                <p className="mt-2 text-lg font-bold text-volt" data-id="element-135" data-mp="25z2cmyl1i6sw">{b.subtitle}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-mist" data-id="element-136" data-mp="32qw647cgoxfk">{b.description}</p>

                <p className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-137" data-mp="2yr5k0gxvr5hd">What’s included</p>
                <ul className="mt-3 space-y-2.5" data-id="element-138" data-mp="2towrflox65fs">
                  {b.included.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-white" data-id="element-139" data-mp="2orem05a428cj">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-140" data-mp="1icvwtq5djms4" />
                      {item}
                    </li>)}
                </ul>

                <div className="mt-6 rounded-2xl bg-panel p-4 ring-1 ring-line" data-id="element-141" data-mp="136gedp3zbcsf">
                  <p className="flex items-center gap-2 font-display text-lg font-bold uppercase text-amber" data-id="element-142" data-mp="1885sxeqeu8l9">
                    <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-143" data-mp="1d4nr1vr8j8om" /> Practical benefit
                  </p>
                  <p className="mt-1 text-[16px] leading-relaxed text-white" data-id="element-144" data-mp="1hza6ca0ftldz">{b.benefit}</p>
                  {b.note && <p className="mt-2 text-sm italic leading-relaxed text-mist" data-id="element-145" data-mp="1m1eyf4b8m9yi">{b.note}</p>}
                </div>

                <p className="mt-auto pt-6 text-center font-display text-2xl font-extrabold uppercase text-ok lg:text-left" data-id="element-146" data-mp="1vxhxu2epfuhr">
                  Included free
                </p>
              </div>
            </article>)}
        </div>

        <TransformCta label="Claim my 5 free bonuses now" data-id="element-147" data-mp="1kijsdpz38cl" />
      </div>
    </section>;
}